import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiUser, FiLogOut, FiChevronDown } from 'react-icons/fi';
import config_names from './config_names';

function AppHeader({ currentUser, onSignOut }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const logoSrc = `${process.env.PUBLIC_URL}/logo-mark.svg`;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="app-header">
      <div className="header-logo">
        <Link to="/dashboard" className="logo-link">
          <img src={logoSrc} alt={`${config_names.projectName} logo`} className="logo-icon" />
          <span>{config_names.projectName}</span>
        </Link>
      </div>
      
      {currentUser ? (
        <div className="user-controls" ref={dropdownRef}>
          <div 
            className="user-info-button"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="user-info">
              <FiUser />
              <span>{currentUser.email}</span>
              <FiChevronDown size={16} />
            </div>
          </div>
          
          {showDropdown && (
            <div className="user-dropdown">
              <Link to="/dashboard/profile" className="dropdown-item" onClick={() => setShowDropdown(false)}>
                <FiUser />
                <span>Profile</span>
              </Link>
              <button className="dropdown-item" onClick={onSignOut}>
                <FiLogOut />
                <span>Sign Out</span>
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="auth-controls">
          <Link to="/login" className="secondary-button">
            Log In
          </Link>
          <Link to="/signup" className="primary-button">
            Sign Up
          </Link>
        </div>
      )}
    </header>
  );
}

export default AppHeader;
